"use client";
import React, { useState } from "react";

type TableRow = {
  label: string;
  values: { [key: string]: string };
};

type TrailingReturnsTableProps = {
  data: TableRow[];
  switchMode?: boolean;
};

const shortTermHeaders = ["Period", "1W", "1M", "3M", "6M"];
const longTermHeaders = ["Period", "1Y", "2Y", "3Y", "5Y"];

const TrailingReturnsTable: React.FC<TrailingReturnsTableProps> = ({ data, switchMode = false }) => {
  const [selectedTerm, setSelectedTerm] = useState<"short" | "long">("short");

  const headers = switchMode ? (selectedTerm === "short" ? shortTermHeaders : longTermHeaders) : shortTermHeaders;

  return (
    <>
      {switchMode && (
        <div className="flex items-center justify-between mb-3 sm:mb-6">
          <div className="inline-flex rounded-[100px] bg-[#EBF3FF] text-sm sm:text-base border border-[#1A51AA24] p-1">
            <button onClick={() => setSelectedTerm("short")} className={`px-2.5 sm:px-4 py-1 rounded-[100px] transition ${selectedTerm === "short" ? "bg-white text-primaryBlue" : "text-[#202020A6] hover:text-primaryBlue"}`}>
              Short Term
            </button>
            <button onClick={() => setSelectedTerm("long")} className={`px-2.5 sm:px-4 py-1 rounded-[100px] transition ${selectedTerm === "long" ? "bg-white text-primaryBlue" : "text-[#202020A6] hover:text-primaryBlue"}`}>
              Long Term
            </button>
          </div>
          <p className="hidden sm:block text-xs text-[#6E6E73] font-medium">{selectedTerm === "short" ? "*All Returns are Absolute" : "*All Returns are Annualized"}</p>
        </div>
      )}

      <div className={`rounded-4xl scrollbar-xs overflow-x-auto text-sm text-primaryBlack ${switchMode ? "border-none" : "bg-white border border-[#E9E9EB] py-2.5 px-5 sm:py-3 sm:px-6"}`}>
        <table className="w-full">
          <thead>
            <tr className="text-[#444444] font-semibold">
              {headers.map((header, index) => (
                <th key={index} className="text-center first:text-left py-2.5 px-3 sm:py-3 sm:px-4 border-b border-[#E9E9EB]">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIdx) => (
              <tr key={rowIdx} className="border-b last:border-none border-[#E9E9EB]">
                <td className="py-2.5 px-3 sm:py-3 sm:px-4 text-[#343434]">{row.label}</td>
                {headers.slice(1).map((period) => (
                  <td key={period} className="text-center py-2.5 px-3 sm:py-3 sm:px-4 font-medium">
                    {row.values[period] === "-" || !row.values[period] ? (
                      <span className="text-[#949494]">-</span>
                    ) : (
                      <span className={`inline-flex items-center gap-1 ${parseFloat(row.values[period]) < 0 ? "text-red-700" : "text-[#2C841C]"}`}>
                        <i className={`inline-block align-middle mr-1 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent ${parseFloat(row.values[period]) < 0 ? "border-t-[5px] border-t-red-700" : "border-b-[5px] border-b-[#2C841C]"}`} />
                        {parseFloat(row.values[period]).toFixed(2)}%
                      </span>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TrailingReturnsTable;
